import {FACEBOOK_RATING_DETAIL_SUCCESS} from "../../../types";


/**
 * @param {*} state
 * @param {*} action
 */
const RatingDetailReducer = (state = {}, action) => {

    switch (action.type) {
        case FACEBOOK_RATING_DETAIL_SUCCESS:
            return {...state, action};
        default:
            return state;
    }
};

export default RatingDetailReducer;